import Backend from 'backend';
import {ShoppingCart} from './shopping-cart';
import {bindable, customElement, inject, observable} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import {SpecialPriceCalculator} from "./specialPriceCalculator";
import {RMetaPixel} from "../../util/r-meta-pixel";
import {RGTag} from "../../util/r-gtag";

@customElement('week-extra-component')
@inject(Element, ShoppingCart, Backend, Router, SpecialPriceCalculator)
export class WeekExtraComponent {
  element;
  backend;
  shoppingCart;
  router;
  specialPriceCalculator;

  @observable({changeHandler: 'chosenProductsChanged'})
  chosenProducts = []; // Bound to sup product component
  initValues = {};

  @observable({changeHandler: 'valueOfGoodsChanged'})
  valueOfGoods;

  @bindable() showFixedBar = true;

  constructor(element, shoppingCart, backend, router, specialPriceCalculator) {
    this.element = element;
    this.shoppingCart = shoppingCart;
    this.backend = backend;
    this.router = router;
    this.specialPriceCalculator = specialPriceCalculator;
  }

  attached() {
    return this.backend.CmsFragmentPublicQueryHandler_handle({items: [
          {cmsFragmentKey: "checkout_flow__week_extra__section1"}
        ]})
      .then(result => {
        this.cmsFragments = result;
      });
  }

  // Switched from attached() to bind() after having issues with loading initValues after going back and forth between checkout steps.
  bind() {
    // Get shopping cart info
    let info = this.shoppingCart.getInfo();
    this.crateName = info.crateProduct.name;

    // Put each in the init values
    this.initValues = {};
    info.weekExtraProducts.forEach(cartSubProduct => {
      this.initValues[cartSubProduct.productId] =
        {
          quantity: cartSubProduct.quantity,
          everyTime: !cartSubProduct.oneTime
        };
    })
  }

  quantityChanged(event) {
    // Track in Meta Pixel only if quantity increased.
    if (event.detail.quantityIncrement > 0) {
      RMetaPixel.trackAddToCart(
        event.detail.productArticleNumber,
        event.detail.priceIncVat);
      RGTag.trackAddToCart(
        event.detail.productArticleNumber,
        event.detail.productName,
        event.detail.priceIncVat);
    }
  }

  valueOfGoodsChanged() {
    // Total price
    this.calculatedPrice = this.specialPriceCalculator.calculateSumIncVat(this.shoppingCart.getInfo().crateProduct.productId, this.valueOfGoods);
  }

  chosenProductsChanged() {
    this.addChosenProductsToCart();
  }

  addChosenProductsToCart() {
    // Store in shopping cart
    let self = this;
    this.shoppingCart.atomic(cart => {
      cart.clearWeekExtraAndCustomizationProducts();
      self.chosenProducts
        // The SubProductComponent allows quantity zero if initValues was non zero because it should be possible to remove items,
        // but that is not necessary here since we are working with client-side data and we just cleared the product list.
        .filter(product => product.quantity > 0)
        .forEach(product => {
            cart.addWeekExtraProducts(product.productId, product.quantity, !product.everyTime);
        });
      });
  }
}
